// extracted by mini-css-extract-plugin
export var container = "_si-0";
export var dotAnimation = "_si-2";
export var dotsLoading = "_si-1";